import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Form } from "react-bootstrap";
import "./login.css";
import sntLogo from "../Assets/sntLogo.png";
import AuthService from "../services/auth.service";
import { ToastContainer, toast } from "react-toastify";

const Login = () => {
  const navigate = useNavigate();
  const [showPass, setShowPass] = useState(false);
  const [details, setDetails] = useState({
    username: "",
    password: "",
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setDetails({ ...details, [name]: value });
  };

  const handleLogin = (event) => {
    event.preventDefault();
    event.stopPropagation();

    // localStorage.setItem("user", JSON.stringify(details));
    // navigate("/centralDashboard");
    // window.location.reload();

    const req = {
      username: details.username,
      password: details.password,
    };

    AuthService.login(req).then(
      (response) => {
        if (response) {
          navigate("/centralDashboard");
          window.location.reload();
        }
      },
      (error) => {
        // alert("Invalid Details!");
        toast.error("Invalid Details !", {
          position: "top-right",
          autoClose: "500",
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          theme: "light",
        });
      }
    );
  };

  const handleShowPass = () => {
    setShowPass(!showPass);
  };

  return (
    <>
      <div className="login-bg">
        <ToastContainer />
        <div className="login-layer"></div>
        <div className="container login-container">
          <div className="row">
            <div className="col-lg-7 col-md-7">
              <div className="login-left">
                <div className="login-form">
                  <div className="logo text-start">
                    <img src={sntLogo} width="200" height="200" alt="" />
                  </div>
                  <div className="heading">
                    <h1>Welcome to SNT IDMS</h1>
                    <p>
                      We welcome you to our brand new Admin Panel. Current look
                      & feel will please you with cool colors & charm
                      personality
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-5 col-md-5">
              <div className="login">
                <div className="login-form">
                  <div className="heading">
                    <h1>Stakeholder</h1>
                    <p>Welcome back.</p>
                    <p>Please login to your account.</p>
                  </div>
                  <Form onSubmit={handleLogin}>
                    <div className="">
                      <div class="form-group mb-3 text-start">
                        <label htmlFor="" className="mb-3">
                          User Name
                        </label>
                        <input
                          type="text"
                          class="form-control"
                          name="username"
                          value={details.username}
                          onChange={handleInputChange}
                        />
                      </div>
                      <div class="form-group mb-3 text-start position-relative">
                        <label htmlFor="" className="mb-3">
                          Password
                        </label>

                        <input
                          name="password"
                          class="form-control"
                          type={showPass ? "text" : "password"}
                          value={details.password}
                          onChange={handleInputChange}
                        />
                        <span
                          className=""
                          style={{
                            cursor: "pointer",
                            position: "absolute",
                            right: "12px",
                            top: "49px",
                          }}
                          onClick={handleShowPass}
                        >
                          {showPass ? (
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              height="20px"
                              viewBox="0 -960 960 960"
                              width="20px"
                              fill="#1f1f1f"
                            >
                              <path d="m644-428-58-58q9-47-27-88t-93-32l-58-58q17-8 34.5-12t37.5-4q75 0 127.5 52.5T660-500q0 20-4 37.5T644-428Zm128 126-58-56q38-29 67.5-63.5T832-500q-50-101-143.5-160.5T480-720q-29 0-57 4t-55 12l-62-62q41-17 84-25.5t90-8.5q151 0 269 83.5T920-500q-23 59-60.5 109.5T772-302Zm20 246L624-222q-35 11-70.5 16.5T480-200q-151 0-269-83.5T40-500q21-53 53-98.5t73-81.5L56-792l56-56 736 736-56 56ZM222-624q-29 26-53 57t-41 67q50 101 143.5 160.5T480-280q20 0 39-2.5t39-5.5l-36-38q-11 3-21 4.5t-21 1.5q-75 0-127.5-52.5T300-500q0-11 1.5-21t4.5-21l-84-82Zm319 93Zm-151 75Z" />
                            </svg>
                          ) : (
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              height="20px"
                              viewBox="0 -960 960 960"
                              width="20px"
                              fill="#1f1f1f"
                            >
                              <path d="M480-320q75 0 127.5-52.5T660-500q0-75-52.5-127.5T480-680q-75 0-127.5 52.5T300-500q0 75 52.5 127.5T480-320Zm0-72q-45 0-76.5-31.5T372-500q0-45 31.5-76.5T480-608q45 0 76.5 31.5T588-500q0 45-31.5 76.5T480-392Zm0 192q-146 0-266-81.5T40-500q54-137 174-218.5T480-800q146 0 266 81.5T920-500q-54 137-174 218.5T480-200Zm0-300Zm0 220q113 0 207.5-59.5T832-500q-50-101-144.5-160.5T480-720q-113 0-207.5 59.5T128-500q50 101 144.5 160.5T480-280Z" />
                            </svg>
                          )}
                        </span>
                      </div>
                      <div className="form-btn">
                        <button type="submit" className="TextButton">
                          Login
                        </button>
                      </div>
                    </div>
                  </Form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Login;
